import api from '../../apiConfig/apiConfig'
import { Get, Post, Put } from '../base/baseAjax'

export default {
  exportReport(params, url) {
    return Post({
      url: api.fbReport.exportReport + '?serviceSiteId=' + url,
      bodyParam: params,
      config: {
        responseType: 'blob',
      },
    })
  },
  reportData(params, url) {
    return Post({
      url: api.fbReport.reportData + '?serviceSiteId=' + url,
      bodyParam: params,
    })
  },
  pageList(params) {
    return Get({
      url: api.fbReport.pageList,
      UrlParam: params,
    })
  },
  audienceReport(params) {
    return Post({
      url: api.fbReport.audienceReport,
      bodyParam: params,
      config: {
        timeout: 20000,
      },
    })
  },
  audienceReportCountry(params) {
    return Post({
      url: api.fbReport.audienceReportCountry,
      bodyParam: params,
      config: {
        timeout: 20000,
      },
    })
  },
  audienceReportExport(params) {
    return Post({
      url: api.fbReport.audienceReportExport,
      bodyParam: params,
      config: {
        timeout: 20000,
        responseType: 'blob',
      },
    })
  },
}
